// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-Jtails_layout_1cZ3b","isStyleItem":"Layout-Jtails_isStyleItem_2enPN"};